export default __webpack_public_path__ + "static/media/VD-3000.aa39bab8.pdf";